import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/interazioniLayout';
import { selectors, DEFAULT_STATE } from '../reducers/interazioniLayout';
import api from '../apis/interazioniLayout';

const sagas = helper.createSagas(
    'interazioniLayout',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
